<template>
  <el-dialog
      :title="type == 'add' ? '新增授权' : '授权延期'"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="visible"
      width="500px"
      :before-close="handleClose">
    <el-descriptions title="商品信息" v-loading="loading">
      <el-descriptions-item label="商品名">{{ list.productName }}</el-descriptions-item>
      <el-descriptions-item label="价格">{{ list.productPrice }} 元</el-descriptions-item>
      <el-descriptions-item label="使用期限">1年</el-descriptions-item>
    </el-descriptions>
    <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="handleSubmit('wxpay')">微信支付</el-button>
    <el-button type="primary" @click="handleSubmit('alipay')">支付宝支付</el-button>
  </span>

  <pay-dialog
      v-if="payVisible"
      :visible.sync="payVisible"
      :payList="payList"
      :type="payType"
      @closeAll="closeAll"
  />
  </el-dialog>
</template>

<script>

import PayDialog from "@/pages/userCenter/components/payDialog.vue";

export default {
  name: "commodityInformation",
  components: {PayDialog},
  props:{
    visible: {
      type: Boolean,
      default: false
    },
    ukeySn:{
      type: String,
      default: ''
    },
    type:{
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      list:{},
      payVisible: false,
      userId: null,
      payList: {

      },
      payType: '',
      loading: false
    };
  },
  created() {
    this.getApplyAuthProduct()
  },
  computed: {
    user() {
      return this.$store.state.account.user
    },
    isLogin() {
      return this.user && this.user.userId
    }
  },
  mounted() {
    this.userId = this.$auth.getUserId() || this.user.userId
  },
  methods: {
    getApplyAuthProduct(){
      this.loading = true
      this.$http.post(this.$api.register.getProductsInfo, {
        productType: 'applyAuth',
        type: 'user',
      }).then(res => {
        if (res.data.code == 200) {
          if (res.data.data.length > 0){
            this.list = res.data.data[0]
            this.loading = false
          }else {
            this.$message.error('暂无商品信息')
          }
        }else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      });
      // this.$http.post(this.$api.user.getApplyAuthProduct).then(res => {
      //   if (res.data.code == 200) {
      //     this.list = res.data.data[0]
      //     this.loading = false
      //   }
      // })
    },
    handleSubmit(type){
      this.payType = type
      this.payList = {
        buyCount: 1,
        payType: type ,
        productId: this.list.productId ,
        uKeySn: this.ukeySn,
        userId: this.userId
      }
      console.log(this.payList)
      this.payVisible = true
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(()=> {
            this.updateDialog(false)
          })
          .catch(() => {});
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    },
    closeAll(){
      this.payVisible = false
      this.updateDialog(false)
      this.$emit('updateDialog', false);
    }
  }
}
</script>

<style scoped lang="less">

</style>
